'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$16() {
  this.bbe = null;
  this.bbf = false;
}
export { $c_Lpresto_Presto$$anon$16 as $c_Lpresto_Presto$$anon$16 };
$p = $c_Lpresto_Presto$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$16;
/** @constructor */
function $h_Lpresto_Presto$$anon$16() {
}
export { $h_Lpresto_Presto$$anon$16 as $h_Lpresto_Presto$$anon$16 };
$h_Lpresto_Presto$$anon$16.prototype = $p;
$p.P = (function() {
  if ((!this.bbf)) {
    this.bbe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bbf = true;
  }
  return this.bbe;
});
var $d_Lpresto_Presto$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$16, "presto.Presto$$anon$16", ({
  Nc: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_Presto$$anon$16 as $d_Lpresto_Presto$$anon$16 };
//# sourceMappingURL=presto.-Presto$$anon$16.js.map
